import { render, staticRenderFns } from "./News2.vue?vue&type=template&id=10c420d4&scoped=true"
import script from "./News2.vue?vue&type=script&lang=js"
export * from "./News2.vue?vue&type=script&lang=js"
import style0 from "./News2.vue?vue&type=style&index=0&id=10c420d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c420d4",
  null
  
)

export default component.exports